import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  popover: {
    left: "0px !important",
    transformOrigin: "left top !important",
  },
  paper: {
    width: "210px",
    transform: "translateY(5px)",
  },
  actionButton: {
    display: "flex",
    cursor: "pointer",
    textAlign: "center",
    alignItems: "center",
    border: "1px solid #E0E0E0",
    borderRadius: "4px",
    padding: "4px 8px",
    backgroundColor: "#fff",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  actionText: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#000",
    marginRight: "4px",
  },
}));

